import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStatus } from '../hooks/use_auth_status'
import Spinner from './spinner'
import { auth } from '../firebase'

const PrivateRoute = () => {
  const { loggedIn, checkingStatus } = useAuthStatus(auth)

  if (checkingStatus) {
    return <Spinner />
  }

  return loggedIn ? <Outlet /> : <Navigate to="/login" />
}

export default PrivateRoute
